import { MonthlyProductionStatus } from '../types'

export const STATUS_GREEN = '#1fba5d'
export const STATUS_ORANGE = '#ff5100'
export const STATUS_GRAY = '#2c2c2c'

export const statusColor = (status: MonthlyProductionStatus): string => {
  if (status === 'paid') return STATUS_GREEN
  if (status === 'current') return STATUS_ORANGE
  return STATUS_GRAY
}

export const statusLabelKey = (status: MonthlyProductionStatus): string => {
  if (status === 'paid') return 'financial.overview.done'
  if (status === 'current') return 'financial.overview.closing'
  return 'financial.overview.processing'
}
